// Compiles the data needed for a single student's one-page
// assessment report. Pure data shaping only — no rendering/PDF
// concerns live here, so the report layout can change later
// without touching how the data is gathered.
//
// Only ACHIEVED skills are included per DOK level — the report is
// a summary of what a student has accomplished, not a full
// skill-by-skill checklist (that's what the assessment editor is
// for).

export const buildStudentReportData = ({
    student,
    studentState,
    skills = [],
    dokLevels = [],
    subjectName,
    unitName,
    termNumber,
}) => {
    if (!student || !studentState) {
        return null;
    }

    const dokGroups = dokLevels
        .slice()
        .sort(
            (a, b) => a.level - b.level
        )
        .map((dok) => {
            const skillsForLevel = skills
                .filter(
                    (skill) =>
                        skill.dok_level.level ===
                        dok.level
                )
                .sort(
                    (a, b) =>
                        a.display_order -
                        b.display_order
                );

            const achievedSkills = skillsForLevel
                .filter(
                    (skill) =>
                        studentState.entries?.[
                            skill.id
                        ] === true
                )
                .map((skill) => ({
                    id: skill.id,
                    description:
                        skill.skill_description,
                }));

            return {
                level: dok.level,
                description: dok.description,

                proficiency:
                    studentState.dokProficiency?.[
                        dok.level
                    ] || "",

                achievedSkills,
                achievedCount:
                    achievedSkills.length,
                totalCount:
                    skillsForLevel.length,
            };
        });

    return {
        generatedAt: new Date().toISOString(),

        student: {
            id: student.student,
            name: student.student_full_name,
            classLevel: student.class_level,
            sectionLevel: student.section_level,
            academicYear: student.academic_year,
        },

        subjectName: subjectName || "",
        unitName: unitName || "",
        termNumber: termNumber || null,

        overallAssessment:
            studentState.overallAssessment || "",

        educatorComment:
            studentState.educatorComment || "",

        dokGroups,
    };
};
